var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCheckbox(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 25,
    viewBox: "0 0 25 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M21.8125 1C22.5208 1 23.1458 1.27083 23.6875 1.8125C24.2292 2.35417 24.5 2.97917 24.5 3.6875V22.3125C24.5 23.0208 24.2292 23.6458 23.6875 24.1875C23.1458 24.7292 22.5208 25 21.8125 25H3.1875C2.47917 25 1.85417 24.7292 1.3125 24.1875C0.770833 23.6458 0.5 23.0208 0.5 22.3125V3.6875C0.5 2.97917 0.770833 2.35417 1.3125 1.8125C1.85417 1.27083 2.47917 1 3.1875 1H21.8125ZM21.8125 3.6875H3.1875V22.3125H21.8125V3.6875Z",
    fill: "#797D8D"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCheckbox);
export default __webpack_public_path__ + "static/media/checkbox.1dfaf5432fc4d249db543f008f8f114d.svg";
export { ForwardRef as ReactComponent };